import { render } from "./CollapseFolder.vue?vue&type=template&id=9e125238"
import script from "./CollapseFolder.vue?vue&type=script&lang=js"
export * from "./CollapseFolder.vue?vue&type=script&lang=js"

import "./CollapseFolder.vue?vue&type=style&index=0&id=9e125238&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__